// src/utils/SafeAdapterDayjs.js
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from './dayjs';

class SafeAdapterDayjs extends AdapterDayjs {
  getTimezone(value) {
    if (!value || !dayjs.isDayjs(value)) {
      if (process.env.NODE_ENV === 'development' && value != null) {
        // eslint-disable-next-line no-console
        console.warn('[SafeAdapterDayjs] Non-Dayjs value passed to DatePicker:', value, typeof value);
      }
      return 'system';
    }
    return super.getTimezone(value);
  }
}

export default SafeAdapterDayjs;
